var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-rabota-agro-book-card',{staticClass:"book-card",attrs:{"id":`${_vm.bookCard.id}`,"author":_vm.bookCard.author,"name":_vm.bookCard.name,"image":_vm.bookCard.image},on:{"on-click-card":function($event){return _vm.clickCard(_vm.bookCard.slug)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }